"use client";

import { useEffect } from "react";

import {
  linkInstallOnce,
  reportInstallOnce,
} from "@/lib/attribution/apple-ads/client";

/** Mounted once in the root layout, so it runs on the very first screen of
 *  a fresh install (normally /login, before anyone has signed in): reports
 *  the install's Apple Ads attribution. A no-op on the web and on shell
 *  builds without the plugin. See lib/attribution/apple-ads/client.ts. */
export function ShellAdAttributionReport(): null {
  useEffect(() => {
    void reportInstallOnce();
  }, []);
  return null;
}

/** Links the reported install to the signed-in account. Mounted in the
 *  authed layout and on the onboarding finish page (why: see
 *  shell-ad-attribution.test.ts); a no-op on the web, like the report. */
export function ShellAdAttributionLink(): null {
  useEffect(() => {
    void linkInstallOnce();
  }, []);
  return null;
}
